import moment from "moment"
import React, { useEffect, useState } from "react"
import { FlatList, Image, ScrollView, View } from "react-native"
import { useDispatch, useSelector } from "react-redux"
import OrderCard from "../../Componentsv1/OrderCard"
import Colors from "../../constants/Colorsv2"
import { Text, TouchableOpacity } from "../../globalComponents/NativeOverrides"
import { event_getEventByEventId, event_getLeagues, event_getMatchByMatchId, event_getTournamentByTournamentId } from "../../store/actionsv1/events"
import { market_getOrdersByPlayerId } from "../../store/actionsv1/markets"
import { PublicPlayerProps } from "../../store/types/auth_svc"
import { HedgeProps, MarketProps, OrderProps } from "../../store/types/mk_svc"
import { EventProps, LeagueProps, MatchProps, TournamentProps } from "../../store/types/sr_svc"
import { hedge_getHedgesFromPositions } from "../Home/helpers/hedges"
import { order_getOrderStatsFromOrders } from "../Home/helpers/orders"
import EventInfoCard from "./components/EventInfoCard"
import MatchInfoCard from "./components/MatchInfoCard"
import TournamentInfoCard from "./components/TournamentInfoCard"
import { market_getOddsLabel } from "./helpers/markets"
import ALaCartePremium from "../../globalComponents/ALaCartePremium"


const EventOrderScreen = ({ route, navigation }:any) => {
    const [ loaded, setLoaded ] = useState(false)
    const dispatch = useDispatch();
     //Check if the order is in the viewport to get event data
     const app_size:any = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width)
     const market_type:'FREE'|'FOR_MONEY' = useSelector((state:any) => state.auth.market_type, (left, right) => left == right)
     const markets:MarketProps[] = useSelector((state:any) => state.market.markets, (left, right) => left?.length == right?.length);
     const player:PublicPlayerProps | undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id)
     const event:EventProps | undefined = useSelector((state:any) => state.event.events[route.params.event_id], (left, right) => {
        if(left?.time_detail != right?.time_detail){ return false }
        if(left?.event_id != right?.event_id){ return false }
        return true
    })
     const tournament:TournamentProps | undefined = useSelector((state:any) => state.event.tournaments[route.params.event_id], (left, right) => left?.tournament_id == right?.tournament_id)
     const match:MatchProps | undefined = useSelector((state:any) => state.event.matches[route.params.event_id], (left, right) => left?.match_id == right?.match_id)
     const leagues:LeagueProps[] = useSelector((state:any) => state.event.leagues, (left, right) => left.length == right.length)
     const orders_state:{ updated:number, orders:OrderProps[] } = useSelector((state:any) => state.player.orders, (left, right) => {
        if(left.updated !== right.updated){ return false }
        return true
    })
    const orders = orders_state.orders.filter(o => o.event_id == route.params?.event_id && o.event_type == route.params?.event_type && o.market_type == market_type)
    
    let hedges:HedgeProps[] = hedge_getHedgesFromPositions(orders, markets)
    
    useEffect(() => {
        if(!route.params?.event_id || !route.params?.event_type){ return }
        getDataFromServer()
    },[route.params?.event_id, route.params?.event_type])

     const getDataFromServer = async() => {
        if(loaded){ return }
        if(player){ await dispatch(market_getOrdersByPlayerId(player.player_id, 0, true, undefined, route.params.event_id, route.params.event_type))}
        if(route.params.event_type === 'team' && !event){ return await dispatch(event_getEventByEventId(route.params.event_id)) }
        if(route.params.event_type === 'tournament' && !tournament){ return await dispatch(event_getTournamentByTournamentId(route.params.event_id)) }
        if(route.params.event_type === 'match' && !match){ console.log('getting match!'); return await dispatch(event_getMatchByMatchId(route.params.event_id)) }
        if(leagues.length === 0){ return await dispatch(event_getLeagues())}
        setLoaded(true)
    }


    const renderOrders = (data: { item:OrderProps, index:number }) => {
        if(data.item.status === 'cancelled' && data.item.called_amt < 0.01){ return <></> }
        let position_ids = data.item.positions.map(p => p?.position_id.toString())
        let sale_orders = orders.filter((o:OrderProps) => o.selling_position_id && o.status === 'approved' && position_ids.includes(o.selling_position_id.toString()))
        return (
            <View style={{ margin:5, marginRight:15, marginLeft:15 }}>
                <OrderCard hide_event prevent_event_load view_mode='edit' order={data.item} sale_orders={sale_orders} navigation={navigation}/>
            </View>
        )
    }
    if(!route.params.event_id || !route.params.event_type){ return <></> }

    const order_stats = order_getOrderStatsFromOrders(orders)
    const order_stat = order_stats[0]
    const cl = market_type === 'FREE' ? 'E' : '$'
    const hedged_amt = hedges.reduce((a,b) => a + b.cash_rcvd, 0)
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            <ScrollView style={{flex:1}}>
                <ALaCartePremium identifier="premium_order_actions"/>
                <View nativeID='info-header' style={{ padding:10, paddingTop:0 }}>
                    {route.params.event_type === 'team' && event ?
                    <EventInfoCard event={event} league={leagues.find(l => l.league_id == event.league_id)}/>
                    :<></>}
                    {route.params.event_type === 'tournament' && tournament ?
                    <TournamentInfoCard tournament={tournament} league={leagues.find(l => l.league_id == tournament.league_id)}/>
                    :<></>}
                    {route.params.event_type === 'match' && match ?
                    <MatchInfoCard match={match} league={leagues.find(l => l.league_id == match?.tournament?.league_id)} tournament={match?.tournament}/>
                    :<></>}
                    <Image style={{alignSelf:'center', height:1, width:355, marginTop:10, marginBottom:10}} source={require('../../assets/images/faded_line.png')} />
                </View>
                {order_stat ?
                <View nativeID="order_stats" style={{ flexDirection:'row', justifyContent:'center', flexWrap:'wrap' }}>
                    {hedged_amt > 0 ?
                    <TouchableOpacity style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.highlights.highlight400Faded, padding:20, margin:8}} onPress={() => navigation.push('EventHedges', { event_id: route.params.event_id, event_type:route.params.event_type })}>
                        <Text size={14} color={Colors.brand.cobalt}>Hedged Position</Text>
                        <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{cl}{hedged_amt.toFixed(2)}</Text>
                    </TouchableOpacity>
                    :<></>}
                    {order_stat.open_amt > 0 ?
                    <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                        <Text size={14} color={Colors.brand.cobalt}>Unfulfilled Order Amount</Text>
                        <Text size={16} weight='semibold' color={Colors.brand.cyan} style={{ marginTop:3 }}>{cl}{order_stat.open_amt.toFixed(2)}</Text>
                    </View>
                    :<></>}
                    {order_stat.unresolved_stake > 0 ?
                    <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                        <Text size={14} color={Colors.brand.cobalt}>Unsettled Positions</Text>
                        <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{order_stat.unresolved_stake.toFixed(2)} to win {cl}{order_stat.unresolved_potential_winnings.toFixed(2)}</Text>
                    </View>
                    :<></>}
                    {order_stat.original_stake > 0 ?
                    <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                        <Text size={14} color={Colors.brand.cobalt}>Settled Positions</Text>
                        <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{cl}{order_stat.original_stake.toFixed(2)}</Text>
                    </View>
                    :<></>}
                    {order_stat.resolved_stake > 0 ?
                    <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                        <Text size={14} color={Colors.brand.cobalt}>Earnings</Text>
                        <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{cl}{order_stat.earnings.toFixed(2)} ({(order_stat.roi * 100).toFixed(2)}%)</Text>
                    </View>
                    :<></>}
                    {order_stat.delayed_cash > 0 ?
                    <View style={{ justifyContent:'space-between', width: (app_size.width/2) - 20, borderRadius:12, backgroundColor:Colors.shades.shade200, padding:20, margin:8}}>
                        <Text size={14} color={Colors.brand.cobalt}>Delayed Cash Out</Text>
                        <Text size={16} weight='semibold' color={Colors.brand.midnight} style={{ marginTop:3 }}>{cl}{order_stat.delayed_cash.toFixed(2)}</Text>
                    </View>
                    :<></>}
                </View>
                
                :<></>}
                <View nativeID="orders">
                    <FlatList data={orders.sort((a,b) => moment(b.create_datetime).unix() - moment(a.create_datetime).unix()).filter(o => o.buy_sell_ind === 'buy')} renderItem={renderOrders} keyExtractor={(item) => item.order_id.toString()}/>
                </View>
            </ScrollView>
        </View>
    )
}


export default EventOrderScreen